import { getStore } from '@/store/index';
import { SHOW_TOAST } from '@/store/modules/toastModule';
import NotificationToast from '@/common/interfaces/modules/NotificationToast';

export const showToastMessage = (messages: NotificationToast[], delay: number = 5000) => {
  getStore().dispatch(SHOW_TOAST, [messages, delay]);
};
